const INFO = {
	main: {
		title: "Shivam Mehta - Full Stack Developer",
		name: "Shivam Mehta",
		email: "contact@shivamehta.com",
		logo: "../profile.jpg",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/shivam2397",
		linkedin: "https://linkedin.com/",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
		upwork: "https://www.upwork.com/freelancers/~",
	},

	homepage: {
		title: "Hi, I'm Shivam Mehta",
		description:
			"I design and build products that deliver real impact. BASED IN United States. Full Stack Developer • Software Engineer",
	},

	about: {
		title: "Building the bridge between ideas and experiences",
		description:
			"I'm Shivam Mehta, an engineering-driven developer who turns complex technical challenges into high-speed web products. I manage the entire stack with a focus on clean, reusable code and seamless performance. I excel in modern web technologies and full-stack architecture, always delivering solutions that actually solve problems for every user. My code is built to last, helping businesses reach the next level. With 5+ years of experience and 60+ successful projects delivered, I've helped clients increase revenue by an average of 35% and reduce operational costs by 40%. I'm committed to delivering not just code, but real business value that drives growth and success.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Modern E-Commerce Solution",
			description:
				"A full-stack e-commerce platform with real-time inventory management, secure payment processing, and advanced analytics. Built with microservices architecture for scalability. Technologies: React, Node.js, MongoDB, AWS. Results: 45% revenue increase, 80% reduction in page load time, automated inventory management saved 20 hours/week.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "More Details",
			link: "#",
		},

		{
			title: "Cloud-Based Project Management",
			description:
				"A comprehensive project management SaaS with team collaboration, time tracking, and automated reporting. Features real-time updates and seamless integrations. Technologies: Next.js, TypeScript, PostgreSQL, Redis. Results: 50% reduction in project delivery time, 40% more projects with same team size, 95% on-time delivery rate.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "More Details",
			link: "#",
		},

		{
			title: "Cross-Platform Mobile Application",
			description:
				"A feature-rich mobile application with offline capabilities, push notifications, and social integration. Optimized for both iOS and Android platforms. Technologies: React Native, Firebase, GraphQL, Expo. Results: 3x increase in daily active users, $120K in-app purchases in first quarter, 60% cost reduction with single codebase.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "More Details",
			link: "#",
		},

		{
			title: "RESTful API Platform",
			description:
				"A scalable RESTful API with comprehensive documentation, rate limiting, and authentication. Built with best practices for security and performance. Technologies: Express.js, JWT, Docker, Swagger. Results: 99.9% uptime, 70% reduction in debugging time, $12K/month cost savings from rate limiting.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "More Details",
			link: "#",
		},

		{
			title: "Real-Time Analytics Dashboard",
			description:
				"An interactive dashboard with real-time data visualization, custom reports, and predictive analytics. Handles millions of data points with sub-second response times. Technologies: Vue.js, Python, D3.js, Elasticsearch. Results: $250K opportunities captured, 22% revenue increase, 30 hours/week time savings.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "More Details",
			link: "#",
		},

		{
			title: "AI-Powered Content Platform",
			description:
				"A content management platform with AI-powered recommendations, automated content generation, and intelligent search capabilities. Technologies: React, TensorFlow, OpenAI, FastAPI. Results: 65% increase in session time, 50% reduction in content costs, 35% increase in ad revenue.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "More Details",
			link: "#",
		},
	],
};

export default INFO;
